export function stringFormatForTestAttr(s: string | undefined) {
  return s === undefined ? '' : s.toLowerCase().replace(/\s+/g, '-');
}
